import { createSelector } from "@reduxjs/toolkit";
//#region src/redux/posts/selectors.ts
var pickPostsState = () => (store) => store.posts;
var selectPosts = () => createSelector([pickPostsState()], (postsState) => postsState.posts);
var selectArePostsPending = () => createSelector([pickPostsState()], (postsState) => postsState.isPending);
var selectPostsErrorMessage = () => createSelector([pickPostsState()], (postsState) => postsState.errorMessage);
//#endregion
export { pickPostsState, selectArePostsPending, selectPosts, selectPostsErrorMessage };

//# sourceMappingURL=selectors.js.map